import type React from 'react';
import classNames from '../../utils/classNames';

const sizeClasses = {
    sm: 'px-4 py-1 text-xs',
    md: 'px-6 py-1.5 text-sm',
    lg: 'px-8 py-2 text-base',
};

const statusClasses = {
    active: 'border-green-500 text-green-600',
    inactive: 'border-yellow-400 text-yellow-500',
    archived: 'border-gray-300 text-gray-300',
};

const statusLabels = {
    active: gettext('ACTIVE'),
    inactive: gettext('INACTIVE'),
    archived: gettext('ARCHIVED'),
} as const;

export function StatusBadge({
    status = 'active',
    label,
    icon,
    size = 'sm',
    className = '',
    id,
}: Props) {
    const resolvedLabel = label ?? statusLabels[status];

    return (
        <span
            id={id}
            role="status"
            aria-live="polite"
            aria-label={resolvedLabel}
            className={classNames(
                'inline-flex select-none items-center justify-center rounded-full border bg-white',
                sizeClasses[size],
                statusClasses[status],
                icon && 'gap-1',
                className
            )}
        >
            {icon}
            {resolvedLabel}
        </span>
    );
}

interface Props {
    status?: 'active' | 'inactive' | 'archived';
    label?: string;
    icon?: React.ReactNode;
    size?: keyof typeof sizeClasses;
    className?: string;
    id?: string;
}

export default StatusBadge;
